import { render, staticRenderFns } from "./InteractiveMenu.vue?vue&type=template&id=a1bea04e&scoped=true&"
import script from "./InteractiveMenu.vue?vue&type=script&lang=js&"
export * from "./InteractiveMenu.vue?vue&type=script&lang=js&"
import style0 from "./InteractiveMenu.vue?vue&type=style&index=0&id=a1bea04e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1bea04e",
  null
  
)

export default component.exports